import script from "./ExtratoTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtratoTab.vue?vue&type=script&setup=true&lang=js"

import "./ExtratoTab.vue?vue&type=style&index=0&id=69c8b97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c8b97a"]])

export default __exports__